precision highp float;

uniform float time;
uniform float size;
uniform float pixelRatio;

attribute float aRandom;
attribute float aAlpha;

varying float vAlpha;
varying float vRandom;
varying vec3 vWorldPos;

void main() {
  vec3 pos = position;
  float r = aRandom;
  float t = time * 0.6;

  float swayY = sin(t + r * 6.2831853) * 0.05;
  float swirl = sin((t * 0.35) + pos.y * 1.6 + r * 10.0) * 0.02;

  vec3 animated = pos + vec3(
    sin(pos.y * 1.5 + t + r * 5.0) * 0.02,
    swayY + swirl,
    cos(pos.x * 1.2 + t * 0.4 + r) * 0.02
  );

  vec4 mvPosition = modelViewMatrix * vec4(animated, 1.0);

  float depth = max(-mvPosition.z, 0.0001);
  float psize = size * (1.0 + r * 0.8) * (pixelRatio / depth);
  psize = clamp(psize, 4.0, 200.0);

  gl_PointSize = psize;
  gl_Position = projectionMatrix * mvPosition;

  vAlpha = (0.25 + 0.75 * r) * aAlpha;
  vRandom = r;
  vWorldPos = (modelMatrix * vec4(animated, 1.0)).xyz;
}